import React, { useEffect, createRef } from 'react';
import styles from './styles.scss';
import Typography from 'Components/Typography';
import { Col, Container, Row } from '../../components/Grid';

const FormSuccessMessage = () => {
  const headlineRef = createRef(null);

  useEffect(() => {
    headlineRef.current.setAttribute('tabindex', '-1');
    headlineRef.current.focus();
  }, []);

  return (
    <Container>
      <Row className={styles.marginS}>
        <Col>
          <Typography.Headline
            ref={headlineRef}
            value="Vielen Dank"
            level="h3"
            forceUppercase={true}
            additionalProps={{
              id: 'modal-redesign-headline',
            }}
          />
          <p role="alert" aria-live="assertive">
            Ihre Anfrage wurde erfolgreich versandt. Wir melden uns in Kürze bei Ihnen, um einen
            Termin zu vereinbaren.
          </p>
          <p>
            Mit freundlichen Grüßen,
            <br />
            Ihr Autohaus Team
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default FormSuccessMessage;
